<template>
  <div class="row">
    <div class="col-12 mb-3">
      <button class="btn btn-primary" @click="$router.push({name: 'edit_category' , params: {id: 'new'}})">
        افزودن
        <i class="fas fa-plus"/>
      </button>
      <hr>
    </div>
    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو دسته بندی ها
      </h4>
    </div>
    <div class="col-12">
      <form class="text-right" v-on:keyup.enter="search">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="search">
              <label for="title" class="text-right mb-1">عنوان</label>
              <input id="title" v-model="filters.title" type="text" class="fv-sm form-control" placeholder="عنوان">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group">
              <label for="order" class="text-right mb-1">ترتیب</label>
              <input id="order" v-model.number="filters.order" type="number" class="fv-sm form-control"
                     placeholder="ترتیب">
            </div>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="search">
              <label for="enable" class="text-right mb-1">فعال</label>
              <fv-switch id="enable" class="d-block" placeholder="فعال"
                         v-model="filters.enabled"/>
            </div>
          </div>
          <div class="col-12 text-left">
            <button @click.prevent="search" class="btn btn-info">
              جستجو
              <i class="fas fa-search"/>
            </button>
          </div>
        </div>
      </form>
      <hr>
    </div>
    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="categories.length > 0" :fields="fields" :rows="categories">
        <template slot="field-#" , slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>
        <template slot="field-عنوان" slot-scope="scope">
          {{scope.row.title || '---'}}
        </template>
        <template slot="field-توضیحات" slot-scope="scope">
          <div v-html="scope.row.description || '---' "/>
        </template>

        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({name: 'edit_category' , params : {id: scope.row.id} })"
                  class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit"/>
          </button>
        </template>
      </fvTable>
    </div>
    <div class="col-12 text-center mt-5" v-if="Object.keys(categories).length > 0 && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>

  </div>
</template>
<script>

	import {mapActions} from "vuex"
	import appPagination from "../../components/appPagination";

	export default {
		name: 'categories',
		data() {
			const {query} = this.$route
			const {page, filters, sort} = query;
			const filtersObj = filters ? JSON.parse(filters) : {}
			return {
				...mapActions('main', [
					'crud'
				]),
				categories: [],
				fields: ['#', 'عنوان', 'توضیحات', 'actions'],
				query,
				filters: filtersObj,
				sort: sort || '-_score,-created_at',
				page: parseInt(page) || 1,
				pagination: {}
			}
		},
		components: {
			appPagination
		},
		methods: {

			parseQueries() {
				const {query} = this.$route
				const {page, filters, sort, per_page} = query;
				const filtersObj = filters ? JSON.parse(filters) : {enabled: true}


				this.sort = sort || '-_score,-created_at'
				this.filters = filtersObj
				this.query = query
				this.page = page ? parseInt(page) : 1
				this.pagination.per_page = per_page
			},
			async getData() {
				this.parseQueries()
				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const apiFilters = await this.$generateFilter(this.filters)
					const categories = await this.crud({
						action: 'get',
						section: 'categories',
						query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`
					})

					if (categories.data && categories.data.items) {
						const result = categories.data.items
						this.categories = result
						this.pagination = categories.data.pagination
					}
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async search() {
				this.filters = await this.$validateFilter(this.filters)
				await this.$router.push({
					query: {
						filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
						sort: this.sort || undefined,
						page: this.page
					}
				})
			}
		},

		async created() {
			await this.getData()
		},
		watch: {
			'$route.query'() {
				this.getData();
			}
		},

		// beforeUpdate() {
		// }
	};
</script>
<style>
</style>
